module.exports = __webpack_public_path__ + "static/media/scan1.33ad31be.png";